import React from 'react';
import Icon from '../../../../../../muiComponents/Icon';
import useTranslate from '../../../../../../customHooks/useTranslate';
import { useZitoneoSettingsChecks } from '../../../../contexts/ZitoneoContentContext';

const SavedCheck = () => {
    const translate = useTranslate();
    const { hasUnsavedChanges } = useZitoneoSettingsChecks();

    const title = hasUnsavedChanges ? 'unsaved_changes' : 'saved_changes';
    const subtitle = hasUnsavedChanges
        ? 'unsaved_changes_subtitle'
        : 'saved_changes_subtitle';

    const icon = hasUnsavedChanges ? 'WarningAmber' : 'Check';

    return (
        <li className='sidebar__quality_signal__item'>
            <div className='flex-column gap-8'>
                <div className='quality_signal__item__title'>
                    <Icon
                        iconName={icon}
                        className={`quality_signal__item__icon --${
                            hasUnsavedChanges ? 'warning' : 'success'
                        }`}
                    />
                    <p>{translate(title)}</p>
                </div>
                {subtitle && <p>{translate(subtitle)}</p>}
            </div>
        </li>
    );
};

export default SavedCheck;
